import { Component, OnInit, OnDestroy, NgZone} from '@angular/core';
import {  NavController, NavParams,LoadingController,ToastController,ViewController  } from 'ionic-angular';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';
import { LoteDAO } from '../../daos/lote-dao';
import { RecebeLote } from '../../entities/recebe-lote';
import { Usuario } from '../../entities/usuario';
import Quagga from 'quagga'; // Importe QuaggaJS



import * as _ from 'lodash';

interface IObterLote {
  Id: string;
  NumLote: number;
  Referencia: string;
  Tam: string;
  CodCor: number;
  DesCor: string;
  Quantidade: number;
  Colecao: number;
  OC: number;
  CodRevisor: number;
  NomeRevisor: string;
  CodCelula: number;
  NomeCelula: string;
  Empresa: Empresa;
}

@Component({
  selector: 'page-receber-lote-novo',
  templateUrl: 'receber-lote-novo.html',
})

export class ReceberLoteNovoPage implements OnInit, OnDestroy
 { 

  scanning: boolean = false;
  mostrarLeitor: boolean = false;
  barcodeResultCode: string = '';
  resultMessage: string = 'Clique em "Iniciar Leitura" para começar';
  hasError: boolean = false;
  errorMessage: string = '';

  // Variável para armazenar o stream de vídeo, para que possamos pará-lo manualmente
  private videoStream: MediaStream | null = null; 

  public usuario: Usuario;
  public obterLoteProducao: IObterLote;
  public carregandoDados: boolean = true;
  public lote: RecebeLote = new RecebeLote();
  public pesquisaLote: any;

 
  constructor(public navCtrl: NavController, public _navParams: NavParams,private _api: Api,
    private _loteDAO: LoteDAO,
    private _loadingCtrl: LoadingController,
    private _viewCtrl: ViewController,
    private _toastCtrl: ToastController,
  private ngZone: NgZone) {
      this.usuario = _navParams.get('usuario');
  }

  //código barra
  ngOnInit() {
    // O Quagga.init será chamado apenas quando o usuário clicar em Iniciar Leitura.
    // As verificações iniciais do Chrome podem ser tratadas na função startScanner.
  }

  ngOnDestroy() {
    // Garante que o scanner seja parado ao sair da página
    this.stopScanner();
  }

  // Exibe mensagens de erro padronizadas
  private displayError(message: string) {
    this.ngZone.run(() => { // Garante que a UI seja atualizada dentro da zona Angular
      this.errorMessage = message;
      this.hasError = true;
      this.scanning = false; // Desabilita o scanning se houver erro crítico
      this.resultMessage = 'Erro na câmera.';
    });
  }

  // Esconde mensagens de erro
  private hideError() {
    this.ngZone.run(() => {
      this.errorMessage = '';
      this.hasError = false;
    });
  }

  async startScanner() {
    
    this.mostrarLeitor = true;
    if (this.scanning) {
      return; // Já está escaneando
    }

    this.hideError();
    this.barcodeResultCode = ''; // Limpa o campo do lote
    this.resultMessage = "Iniciando câmera...";
    this.scanning = true; // Define o estado de scanning como true

    // Referência ao elemento onde o Quagga injetará o vídeo/canvas
    const interactiveDiv = document.getElementById('interactive');
    if (!interactiveDiv) {
      this.displayError("Elemento #interactive não encontrado.");
      return;
    }

    try {
      // 1. Obter permissão da câmera e o stream manualmente
      // Isso é mais robusto para capturar erros de permissão antes de Quagga.init
      this.videoStream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment", // Prioriza a câmera traseira
          width: { min: 640, ideal: 1280 },
          height: { min: 480, ideal: 720 }
        }
      });

      // Se o stream for obtido com sucesso, inicializa Quagga
      await new Promise<void>((resolve, reject) => {
        Quagga.init({
            inputStream: {
                name: "Live",
                type: "LiveStream",
                target: interactiveDiv, // Quagga vai injetar o vídeo e canvas aqui
                constraints: {
                    facingMode: "environment",
                    width: { min: 640, ideal: 1280 }, // Replicar constraints do getUserMedia para consistência
                    height: { min: 480, ideal: 720 }  
                },
            },
            frequency: 10, // Frequência de processamento (em ms)
            decoder: {
                readers: [
                    "ean_reader",
                    "ean_8_reader",
                    "code_128_reader",
                    "code_39_reader",
                    "codabar_reader",
                    "upc_reader",
                    "upc_e_reader",
                    "i2of5_reader", // Adicionado para mais compatibilidade
                    "2of5_reader"   // Adicionado para mais compatibilidade
                ]
            },
            locate: true, // Desenha o localizador do código de barras
            debug: { // Adiciona um pouco de debug visual, útil para ver como o Quagga está "vendo" o código
              drawBoundingBox: true,
              drawScanline: true,
              showPattern: true
            }
        }, (err: any) => {
            if (err) {
                console.error("Erro ao inicializar Quagga:", err);
                reject(err);
                return;
            }
            this.ngZone.run(() => { // Força a atualização da UI
                this.resultMessage = "Aponte para o código de barras...";
            });
            Quagga.start();
            resolve();
        });
      });

      // Configura os listeners do Quagga
      Quagga.onDetected((result: any) => {
        // Usa ngZone.run para garantir que as mudanças de estado atualizem a UI do Angular
        this.ngZone.run(() => {
          if (!this.scanning) return; // Garante que só processa se o scanner ainda estiver ativo

          const code = result.codeResult.code;
          if (code) {
            this.barcodeResultCode = code;
            this.resultMessage = `<strong>Código detectado:</strong> ${code}`;

            // Feedback visual e tátil
            if (navigator.vibrate) {
              navigator.vibrate(100);
            }
            // Não há mais uma classe 'detected' no seu CSS original, então removi.
            // Se você quiser feedback visual, adicione uma classe CSS e gerencie aqui.
            // interactiveDiv.classList.add('detected');
            // setTimeout(() => interactiveDiv.classList.remove('detected'), 300);

            // Opcional: Parar o scanner automaticamente após a primeira detecção
            // this.stopScanner();
          }
        });
      });

      // Opcional: Quagga.onProcessed para debug visual dos quadros
      Quagga.onProcessed((result: any) => {
          const drawingCtx = Quagga.canvas.ctx.overlay;
          const drawingCanvas = Quagga.canvas.dom.overlay;

          if (drawingCtx && drawingCanvas) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')!), parseInt(drawingCanvas.getAttribute('height')!));
              if (result && result.boxes) {
                  result.boxes.filter((box: any) => box !== result.box).forEach((box: any) => {
                      Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
                  });
              }
              if (result && result.box) {
                  Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
              }
              if (result && result.codeResult && result.codeResult.code) {
                  Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: "red", lineWidth: 3 });
              }
          }
      });


    } catch (err) {
      this.handleCameraError(err);
      this.stopScanner(); // Garante que o scanner pare em caso de erro
    }
  }

  stopScanner() {
    this.mostrarLeitor = false;
    this.ngZone.run(() => { // Força a atualização da UI
      if (this.scanning) {
        Quagga.stop(); // Parar Quagga
        this.scanning = false;
        this.resultMessage = 'Leitura parada. Clique em Iniciar para escanear novamente.';
        this.hideError(); // Limpa qualquer erro existente ao parar

        // Para o stream de vídeo da câmera
        if (this.videoStream) {
          this.videoStream.getTracks().forEach(track => track.stop());
          this.videoStream = null;
        }

        // Limpa o srcObject do elemento video se ele foi criado pelo Quagga
        const interactiveDiv = document.getElementById('interactive');
        if (interactiveDiv) {
            const videoElement = interactiveDiv.querySelector('video');
            if (videoElement) {
                videoElement.srcObject = null;
            }
        }
        console.log('Leitor parado.');
        this.buscaLote(parseInt(this.barcodeResultCode));
      }
    });
  }

  // Lida com erros da API MediaDevices (getUserMedia)
  private handleCameraError(err: any) {
    let errorMessage = "Erro desconhecido ao acessar a câmera.";
    console.error("Erro ao acessar a câmera:", err);

    if (err.name === 'NotAllowedError') {
      errorMessage = `
        <strong>Permissão negada!</strong><br>
        Para usar o leitor, você precisa conceder permissão de acesso à câmera.<br>
        <ul>
          <li><strong>No navegador:</strong> Clique no ícone de cadeado (🔒) na barra de endereço e "Permitir" o acesso à câmera.</li>
          <li><strong>No Android/iOS:</strong> Vá nas configurações do seu dispositivo, encontre as permissões do aplicativo e ative o acesso à câmera.</li>
        </ul>
        Após alterar, recarregue a página/app.
      `;
    } else if (err.name === 'NotFoundError') {
      errorMessage = "Nenhuma câmera encontrada no seu dispositivo. Verifique se a câmera está conectada e disponível.";
    } else if (err.name === 'NotReadableError') {
      errorMessage = "A câmera está sendo usada por outro aplicativo ou está indisponível. Por favor, feche outros aplicativos que usam a câmera e tente novamente.";
    } else if (err.name === 'OverconstrainedError') {
      errorMessage = "As configurações de câmera solicitadas (resolução, etc.) não são suportadas pelo seu dispositivo.";
    } else if (err.name === 'AbortError') {
      errorMessage = "O acesso à câmera foi abortado. Isso pode ser devido a um software de segurança ou antivírus.";
    } else {
      errorMessage += `<br>Detalhes: ${err.message || err.name || JSON.stringify(err)}`;
    }
    
    this.displayError(errorMessage);
  }

  //fim código barra

  

  private _obterLote(idEmpresa: number,seqLote: number): Promise<IObterLote[]> {
    return new Promise((resolve, reject) => {
      this._api.get(`RecebeLote/InfoLote/${idEmpresa}/${seqLote}`).subscribe(response =>         
        resolve(JSON.parse(response._body)), reject);       
  
    });
  }  

  public focus(): void {
      this.pesquisaLote = [];
      this.carregandoDados = true;
  }

  public change(): void {
    this.pesquisaLote = [];
    this.carregandoDados = true;
  }


  public buscaLote(seqLote: number): void {
    if (seqLote > 0){
      this._loteDAO.checarLote(this.usuario.Empresa.Id,seqLote).then(loteReceber =>{
        if (Object.keys(loteReceber).length === 0) {
          this._consultarLote(seqLote);
        }else{
          this._toastCtrl.create({
            message: 'Lote '+seqLote+' já lido pelo usuário '+loteReceber.Usuario.NomeUsuario,
            duration: 3000
        }).present(); 
        }
      })

      
    }    
  }

  private _consultarLote(seqLote: number): void {
    let load = this._loadingCtrl.create({ content: 'Obtendo lote ...' });
    load.present();

    this._obterLote(this.usuario.Empresa.Id,seqLote).then(lote => {    

      if (lote.length > 0) {
        this.obterLoteProducao = lote.find(a => _.isEqual(a.Empresa.Id, this.usuario.Empresa.Id));

        load.dismiss();
        setTimeout(() => {
          this.carregandoDados = false;
        }, 1000);
      }else{
        throw new SyntaxError("Retornou vazio");
      }
      
    }).catch(error => {
      this._toastCtrl.create({
          message: 'Ocorreu um erro ao tentar obter o lote. Tente novamente!',
          duration: 3000
      }).present();
      console.error(error);
      load.dismiss();
    });
  }


  public receberLote(): void {
    if (this.carregandoDados){
      this._toastCtrl.create({
          message: 'Lote obrigatório. Favor Verifique!',
          duration: 3000
      }).present();

      return;
    }
    let load = this._loadingCtrl.create({ content: 'Recebendo...' });
        load.present();

        this.lote.Id=1;
        this.lote.NumLote = this.obterLoteProducao.NumLote;
        this.lote.Usuario = this.usuario;
        this.lote.Empresa = this.usuario.Empresa;
        
        this._loteDAO.receberNovoLote(this.lote).then(() => {
          load.dismiss().then(() => {
              this._toastCtrl.create({
                  message: 'Lote recebido com sucesso!',
                  duration: 3000
              }).present().then(() => {
                  this._viewCtrl.dismiss(true);                  
              });
          });
      }).catch((erro) => {
          console.error(erro);
          load.dismiss();
          this._toastCtrl.create({
              message: 'Não foi possível receber o lote, tente novamente!',
              duration: 3000
          }).present();
      });
   


  }




}



// WEBPACK FOOTER //
// ./src/pages/receber-lote-novo/receber-lote-novo.ts